import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.0004 4C19.4335 4.00006 19.7375 4.18335 19.9125 4.5498C20.0874 4.91638 20.05 5.26635 19.8002 5.59961L14.0004 13V19C14.0004 19.2833 13.9039 19.5212 13.7123 19.7129C13.5207 19.9043 13.2834 20 13.0004 20H11.0004C10.7171 20 10.4791 19.9045 10.2875 19.7129C10.0958 19.5212 10.0004 19.2833 10.0004 19V13L4.20056 5.59961C3.9506 5.26629 3.91229 4.91645 4.08728 4.5498C4.26228 4.18315 4.56704 4 5.00036 4H19.0004ZM12.0004 12.2998L16.9506 6H7.05017L12.0004 12.2998Z"
	})
});
export default SvgFilter;
